import React from 'react';
import Accordion from './Accordion';
import "./Accordion.css";

const AccordionFAQ = () => {
  const accordionData = [
    {
      title: 'Qual è l importo minimo per ordine?',
      content: `L'ordine minimo è pari ad Euro 400 + IVA per ogni singola consegna.
      Sotto tale soglia Virtual Logic S.r.l. opera con le seguenti modalità:
      Ordini con imponibile inferiore a 200 Euro + Iva non vengono processati e saranno rifiutati tramite la piattaforma;
      Ordini con imponibile compreso tra 200 Euro + Iva e 399 Euro + IVA:
      Per questi è prevista la possibilità di evasione autorizzando preventivamente nel campo note dell'ordine stesso l'addebito di 14 Euro + IVA per spese di gestione e spedizione. 
      In caso l'ordine venga inoltrato senza questa dicitura il nostro personale provvederà a chiedere al punto ordinante autorizzazione all'addebito delle spese prima di provvedere al rifiuto.
      Ordini con imponibile superiore a 400 Euro + Iva sono congrui al disciplinare e sono processati senza alcun onere per la pubblica amministrazione.`
    },
    {
      title: 'In caso di guasto chi posso contattare?',
      content: `Può inviare una mail descrivendo in modo dettagliato la problematica all indirizzo supporto@virtual-logic.it`
    },
    {
      title: 'Quali sono i tempi di gestione e spedizione?',
      content: `Un ordine viene mediamente gestito entro 3 giorni dalla ricezione, i tempi di spedizione possono variare in base alla disponibilità della merce ma variano dai 2 ai 5 giorni in media.`
    },
    {
      title: 'Qual è il vostro codice di fatturazione?',
      content: `Il nostro codice di fatturazione è: G4AI1U8`
    },
    {
      title: 'Qual è il vostro codice NSO?',
      content: `Il nostro codice NSO è: 0210:03878640238`
    }
  ];

  return (
    <div>
      <div className="accordion">
        {accordionData.map(({ title, content }) => (
          <Accordion title={title} content={content} />
        ))}
      </div>
    </div>
  );
};

export default AccordionFAQ;